import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";


const Header = () => {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // ADMIN LOGIN STATES
  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const handleLogin = () => {
    if (username === "admin" && password === "admin@123") {
      localStorage.setItem("adminMode", "true");
      setShowLogin(false);
      window.location.reload();
    } else {
      alert("Invalid Username or Password");
    }
  };

  

  return (
    <>
      {/* Top Info Bar */}
      <div className="top-bar">
       गट ग्रामपंचायत सोनेगाव | पंचायत समिती कळमेश्वर, जि. नागपूर
      </div>

      {/* Header */}
      <header className="header">
        <div className="header-inner">

          <div className="header-side"></div>

          {/* CENTER */}
          <div className="header-center">
            <img src="/images/sj1.jpg" alt="राष्ट्रीय चिन्ह" className="emblem" />
            <div className="title-box">
              <h1>गट ग्रामपंचायत सोनेगाव</h1>
              <p>ISO 9001:2015 प्रमाणित</p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="header-side personalities">
            <div className="photo-group">
              {[
                "/images/raje.jpg",
                "/images/Gadgemaharaj.jpg",
                "/images/tujdojimaharaj.jpeg",
              ].map((img, i) => (
                <img key={i} src={img} alt="महापुरुष" />
              ))}
            </div>

            
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* NAV */}
        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>
          <Link to="/">मुख्य पृष्ठ</Link>
          <Link to="/aboutus">ग्रामपंचायत-बद्धल</Link>
          <Link to="/sachiv">ग्रामपंचायत-अधिकारी</Link>
          <Link to="/sarpanch">सरपंच</Link>
          <Link to="/upsarpanch">उपसरपंच</Link>
          <Link to="/team">सदस्य/कर्मचारी</Link>
          <Link to="/meeting">ग्रामसभा</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setOpen(!open)}>दाखले ▾</span>
            {open && (
              <div className="dropdown">
                <Link to="/janm-dakhala">जन्म दाखला</Link>
                <Link to="/mrut-dakhala">मृत्यू दाखला</Link>
                <Link to="/vivah-dakhala">विवाह दाखला</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment">विकास कामे</Link>
          <Link to="/gallery">छायाचित्र</Link>
          <Link to="/contact">संपर्क</Link>
        </nav>
      </header>

      {/* LOGIN POPUP */}
      {showLogin && (
        <div className="login-overlay">
          <div className="login-box">
            <h3>Admin Login</h3>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button onClick={handleLogin}>Login</button>
            <button onClick={() => setShowLogin(false)}>Cancel</button>
          </div>
        </div>
      )}

     </>
  );
};

export default Header;
